import { render } from "./ReferralsStatsView.vue?vue&type=template&id=c3940c8a"
import script from "./ReferralsStatsView.vue?vue&type=script&lang=js"
export * from "./ReferralsStatsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__